<template>
  <div class="dashboard-admin">
    <NavBar />

    <div class="dashboard-container">
      <!-- Header Section -->
      <div class="dashboard-header">
        <div class="header-content">
          <div class="title-section">
            <h1 class="page-title">
              <i class="fas fa-map-marked-alt title-icon"></i>
              Dashboard Administrativo
            </h1>
            <p class="page-subtitle">
              Visualização geográfica e controle de dados das instituições
            </p>
          </div>

          <div class="header-stats">
            <div class="stat-card">
              <div class="stat-icon">
                <i class="fas fa-users"></i>
              </div>
              <div class="stat-content">
                <span class="stat-number">{{ residents }}</span>
                <span class="stat-label">Residentes Ativos</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="dashboard-content">
        <!-- Filters Section -->
        <div class="filters-section">
          <div class="filters-card">
            <div class="status-title text-center">STATUS DOS CLIENTES</div>
            <div class="d-flex align-items-center justify-content-center">
              <div class="switch-item status m-1">
                <v-switch
                  v-model="ativo"
                  @change="getRestHomes"
                  class="modern-switch"
                  color="success"
                  dense
                />
                <label class="switch-label">
                  <i class="fas fa-check-circle mr-1"></i>
                  Ativo
                </label>
              </div>

              <div class="switch-item status m-1">
                <v-switch
                  v-model="inativo"
                  @change="getRestHomes"
                  class="modern-switch"
                  color="warning"
                  dense
                />
                <label class="switch-label">
                  <i class="fas fa-pause-circle mr-1"></i>
                  Inativo
                </label>
              </div>

              <div class="switch-item status m-1">
                <v-switch
                  v-model="bloqueado"
                  @change="getRestHomes"
                  class="modern-switch"
                  color="error"
                  dense
                />
                <label class="switch-label">
                  <i class="fas fa-ban mr-1"></i>
                  Bloqueado
                </label>
              </div>

              <div class="switch-item status m-1">
                <v-switch
                  v-model="finance"
                  @change="getRestHomes"
                  class="modern-switch"
                  color="primary"
                  dense
                />
                <label class="switch-label">
                  <i class="fas fa-dollar-sign mr-1"></i>
                  Apenas Financeiro
                </label>
              </div>
            </div>

            <div>
              <v-select
                label="SELECIONAR CLIENTE"
                outlined
                dense
                v-model="rest_home_id"
                item-text="id"
                item-value="id"
                @change="handleChangeRestHomeId"
                :items="allRestHomes"
                class="modern-select"
              >
                <template v-slot:item="{ item }">
                  <div class="client-item">
                    <div class="client-name">{{ item.name }}</div>
                    <div
                      v-if="
                        item.cnpj &&
                        item.cnpj != '0' &&
                        String(item.cnpj).length > 3
                      "
                      class="client-cnpj"
                    >
                      {{ item.cnpj }}
                    </div>
                  </div>
                </template>
                <template v-slot:selection="{ item }">
                  <div class="client-selection-display">
                    {{ item.name }}
                    <span
                      v-if="
                        item.cnpj &&
                        item.cnpj != '0' &&
                        String(item.cnpj).length > 3
                      "
                      class="cnpj-badge"
                    >
                      {{ item.cnpj }}
                    </span>
                  </div>
                </template>
              </v-select>
            </div>

            <!-- Advanced Filters -->
            <div class="row">
              <!-- Filter Type Selection -->
              <div class="col-md-3">
                <label class="filter-label">Tipo de Filtro</label>
                <!-- { label: 'Medicamentos mais prescritos', value: 'USED' }, -->
                <v-select
                  outlined
                  dense
                  v-model="typeFilters"
                  @change="getRestHomes"
                  :items="[
                    { label: 'Últimos cadastrados', value: 'REGISTERED' },
                  ]"
                  item-text="label"
                  item-value="value"
                  class="modern-select-small"
                />
              </div>

              <div
                v-if="typeFilters == 'REGISTERED'"
                class="switch-item evolution col-md-3"
              >
                <v-switch
                  v-model="filterEvolution"
                  @change="getRestHomes"
                  class="modern-switch"
                  color="orange"
                  dense
                />
                <label class="switch-label">
                  <i class="fas fa-notes-medical mr-1"></i>
                  Evoluções
                </label>
              </div>

              <div
                v-if="typeFilters == 'REGISTERED'"
                class="switch-item medicine col-md-3"
              >
                <v-switch
                  v-model="filterMedicine"
                  @change="getRestHomes"
                  class="modern-switch"
                  color="blue"
                  dense
                />
                <label class="switch-label">
                  <i class="fas fa-pills mr-1"></i>
                  Medicamentos
                </label>
              </div>

              <div
                v-if="typeFilters == 'REGISTERED'"
                class="switch-item vital-signs col-md-3"
              >
                <v-switch
                  v-model="filterVitalSign"
                  @change="getRestHomes"
                  class="modern-switch"
                  color="red"
                  dense
                />
                <label class="switch-label">
                  <i class="fas fa-heartbeat mr-1"></i>
                  Sinais Vitais
                </label>
              </div>
              <div class="col-md-6"></div>

              <div
                v-if="
                  typeFilters == 'USED' &&
                  usedFilterMedicine &&
                  countUsedMedicines.length > 0
                "
                class="col-md-12"
              >
                <h4 class="table-title mb-2">
                  <i class="fas fa-chart-bar"></i>
                  Medicamentos mais prescritos
                </h4>
                <v-data-table
                  :headers="headers"
                  :items="countUsedMedicines"
                  class="modern-table"
                  :items-per-page="10"
                  dense
                >
                  <template v-slot:[`item.color`]="{ item }">
                    <span
                      :class="['color-indicator']"
                      :style="`background-color: ${item.color}`"
                    ></span>
                  </template>
                  <template v-slot:no-data>
                    <div class="no-data">
                      <i class="fas fa-search"></i>
                      <span>Nenhum medicamento encontrado</span>
                    </div>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </div>

        <!-- Map Section -->
        <div class="map-section">
          <div class="map-card">
            <b-overlay :show="loading" opacity="0.99" class="loading-overlay">
              <div v-if="allMapItems.length == 0" class="no-results">
                <i class="fas fa-map-marked-alt no-results-icon"></i>
                <h3 class="no-results-title">Nenhum cliente encontrado</h3>
                <p class="no-results-text">
                  Ajuste os filtros para visualizar as instituições no mapa
                </p>
              </div>

              <GmapMap
                v-else
                class="google-map"
                :zoom="zoom"
                :center="{
                  lat: getCurrentMapCenterLat,
                  lng: getCurrentMapCenterLng,
                }"
                map-type-id="hybrid"
                :options="mapOptions"
              >
                <GmapMarker
                  v-for="(item, key) in allMapItems"
                  v-show="item.latitude && item.longitude"
                  :position="getMapCenter(item)"
                  :icon="getMarkerIcon(item)"
                  :clickable="true"
                  :draggable="false"
                  @click="openInfoWindow(key)"
                  :key="`map-${key}`"
                >
                  <GmapInfoWindow
                    :options="{
                      pixelOffset: { width: 0, height: -10 },
                      disableAutoPan: false,
                      maxWidth: 250,
                      closeBoxURL: '',
                    }"
                    :position="getMapCenter(item)"
                    :opened="infoWindowOpened === key"
                    @closeclick="closeInfoWindow"
                  >
                    <div class="info-window-content">
                      <div class="client-info">
                        <img
                          v-if="item.logo_url"
                          :src="item.logo_url"
                          alt="Logo do Cliente"
                          class="client-logo"
                        />

                        <!-- Rest Homes -->
                        <div
                          class="client-details"
                          v-if="item.name || item.address"
                        >
                          <h4 class="client-name">{{ item.name }}</h4>
                          <p
                            v-if="
                              item.cnpj &&
                              item.cnpj != '0' &&
                              String(item.cnpj).length > 3
                            "
                            class="client-cnpj"
                          >
                            {{ item.cnpj }}
                          </p>
                        </div>

                        <div
                          class="client-details"
                          v-if="item.type == 'evolution'"
                        >
                          <div class="detail-type">
                            <i class="fas fa-notes-medical mr-1"></i>
                            Evolução
                          </div>
                          <p class="detail-content">{{ item.text || "--" }}</p>
                        </div>

                        <div
                          class="client-details"
                          v-if="item.type == 'medicine'"
                        >
                          <div class="detail-type">
                            <i class="fas fa-pills mr-1"></i>
                            Medicamento
                          </div>
                          <p class="detail-content">
                            {{ item.medicine_name || "--" }}
                          </p>
                        </div>

                        <div
                          class="client-details"
                          v-if="item.type == 'vitalSign'"
                        >
                          <div class="detail-type">
                            <i class="fas fa-heartbeat mr-1"></i>
                            Sinais Vitais
                          </div>
                          <p class="detail-content">
                            {{ item.vital_signs_type || "--" }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </GmapInfoWindow>
                </GmapMarker>
              </GmapMap>
            </b-overlay>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";
import api from "../services/api";
import { adminData } from "../lib/functions";

export default {
  name: "Dashboard",
  components: {
    NavBar,
  },
  data() {
    return {
      typeFilters: "REGISTERED",
      lastRecords: 10,
      usedRecords: 10,
      residents: 0,
      zoom: 4,
      allMapItems: [],
      countUsedMedicines: [],
      allRestHomes: [],
      filterEvolution: false,
      filterMedicine: false,
      filterVitalSign: false,
      usedFilterMedicine: true,
      infoWindowOpened: null,
      loading: true,
      logo: null,
      ativo: true,
      inativo: false,
      bloqueado: false,
      finance: false,
      rest_home_id: null,
      getCurrentMapCenterLat: -14.235004,
      getCurrentMapCenterLng: -51.92528,
      headers: [
        { text: "", value: "color", width: "40px", sortable: false },
        {
          text: "Medicamento",
          value: "medicine_name",
          sortable: false,
        },
        {
          text: "Quantidade",
          value: "total_quantity",
          width: "100px",
          sortable: false,
        },
      ],
      mapOptions: {
        zoomControl: true,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: true,
        rotateControl: true,
        styles: [
          {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }],
          },
        ],
      },
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getCurrentMapCenter(item = null) {
      if (item) {
        this.getCurrentMapCenterLat = parseFloat(item.latitude);
        this.getCurrentMapCenterLng = parseFloat(item.longitude);
      } else {
        this.getCurrentMapCenterLat = -14.235004;
        this.getCurrentMapCenterLng = -51.92528;
      }
    },
    getMapCenter(item) {
      return {
        lat: parseFloat(item.latitude),
        lng: parseFloat(item.longitude),
      };
    },
    getMarkerIcon({
      color,
      scale,
      fillOpacity = 0.5,
      strokeWeight = 0.7,
      anchor = { x: 192, y: 512 },
      text = null,
    }) {
      const iconConfig = {
        path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0z",
        fillColor: color,
        fillOpacity,
        strokeWeight,
        scale,
        anchor, // Sem usar new google.maps.Point
      };

      if (text) {
        iconConfig.labelOrigin = { x: 192 * scale, y: 200 * scale };
      }

      return iconConfig;
    },
    openInfoWindow(key) {
      this.infoWindowOpened = key;
    },
    closeInfoWindow() {
      this.infoWindowOpened = null;
    },
    async handleChangeRestHomeId() {
      await this.getAllRestHomes();
      await this.getRestHomes();
    },
    async retrieve() {
      let { logo } = adminData();
      this.logo = logo;
      await this.getAllRestHomes();
      await this.getRestHomes();
    },
    async getAllRestHomes() {
      try {
        this.loading = true;
        let { ativo, inativo, bloqueado, finance } = this;
        const response = await api.get("/admin/rest-home/paginate", {
          params: { ativo, inativo, bloqueado, finance },
        });
        const { restHomes } = response.data;
        this.allRestHomes = [
          { id: null, name: "TODOS OS CLIENTES", cnpj: null },
          ...restHomes,
        ];
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getRestHomes() {
      try {
        this.loading = true;
        this.zoom = 4;
        let {
          rest_home_id,
          ativo,
          inativo,
          bloqueado,
          finance,
          lastRecords,
          filterMedicine,
          filterVitalSign,
          filterEvolution,
          typeFilters,
          usedRecords,
          usedFilterMedicine,
        } = this;
        let params = {
          rest_home_id,
          ativo,
          inativo,
          bloqueado,
          finance,
          lastRecords,
          filterMedicine: filterMedicine ? 1 : 0,
          filterVitalSign: filterVitalSign ? 1 : 0,
          filterEvolution: filterEvolution ? 1 : 0,
          typeFilters,
          usedRecords,
          usedFilterMedicine: usedFilterMedicine ? 1 : 0,
        };
        const response = await api.get("/admin/rest-home/dashboard", {
          params,
        });
        const { countUsedMedicines, residents, allMapItems } = response.data;
        this.allMapItems = allMapItems;
        this.countUsedMedicines = countUsedMedicines;
        this.residents = residents;
        if (allMapItems.length == 1 && allMapItems[0].latitude != null) {
          if (rest_home_id) {
            this.zoom = 15;
            this.getCurrentMapCenter(allMapItems[0]);
          }
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.dashboard-admin {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.dashboard-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

/* Header Section */
.dashboard-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.header-stats {
  display: flex;
  gap: 16px;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 12px;
  background: linear-gradient(135deg, #0f65b0 0%, #1e40af 100%);
  color: white;
  padding: 16px 24px;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(15, 101, 176, 0.3);
}

.stat-icon {
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.stat-content {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 24px;
  font-weight: 700;
  line-height: 1;
}

.stat-label {
  font-size: 12px;
  opacity: 0.9;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Content Section */
.dashboard-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 32px;
}

/* Filters Section */
.filters-section {
  margin-bottom: 8px;
}

.filters-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filters-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.filters-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.toggle-filters-btn {
  border-radius: 8px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: #0f65b0 !important;
  color: #0f65b0 !important;
}

.toggle-filters-btn:hover {
  background: #0f65b0 !important;
  color: white !important;
}

.client-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.client-name {
  font-weight: 500;
  color: #1e293b;
}

.client-cnpj {
  font-size: 12px;
  color: #6b7280;
}

.client-selection-display {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cnpj-badge {
  background: #f1f5f9;
  color: #475569;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
}

/* Advanced Filters */
.filter-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.switch-item {
  display: flex;
  align-items: center;
  padding: 0px 8px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.switch-label {
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin: 0;
  display: flex;
  align-items: center;
}

.switch-item.evolution .switch-label {
  color: orange;
}

.switch-item.medicine .switch-label {
  color: blue;
}

.switch-item.vital-signs .switch-label {
  color: red;
}

.status-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.table-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.modern-table {
  border-radius: 8px !important;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
}

.color-indicator {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.no-data {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  color: #6b7280;
  font-style: italic;
  padding: 20px;
}

/* Map Section */
.map-section {
  margin-bottom: 32px;
}

.map-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.loading-overlay {
  border-radius: 16px;
}

.google-map {
  width: 100%;
  height: 70vh;
  min-height: 500px;
}

.no-results {
  text-align: center;
  padding: 80px 24px;
  color: #6b7280;
}

.no-results-icon {
  font-size: 64px;
  color: #d1d5db;
  margin-bottom: 20px;
}

.no-results-title {
  font-size: 24px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
}

.no-results-text {
  font-size: 16px;
  color: #6b7280;
  margin: 0;
}

/* Info Window Styling */
.info-window-content {
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  max-width: 250px;
}

.client-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 12px;
}

.client-logo {
  width: 100%;
  max-width: 120px;
  height: 60px;
  object-fit: contain;
  border-radius: 8px;
  border: 2px solid #f1f5f9;
}

.client-details {
  width: 100%;
}

.client-name {
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 4px 0;
  line-height: 1.2;
}

.client-cnpj {
  font-size: 12px;
  color: #6b7280;
  margin: 0;
  background: #f8fafc;
  padding: 4px 8px;
  border-radius: 4px;
  display: inline-block;
}

.detail-type {
  font-size: 12px;
  font-weight: 600;
  color: #059669;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
  display: flex;
  align-items: center;
}

.detail-content {
  font-size: 14px;
  color: #374151;
  margin: 0;
  line-height: 1.3;
}

/* Override Vuetify Styles */
.modern-select >>> .v-input__control,
.modern-select-small >>> .v-input__control {
  border-radius: 8px !important;
}

.modern-select >>> .v-text-field__slot input,
.modern-select-small >>> .v-text-field__slot input {
  font-weight: 500 !important;
}

.modern-switch >>> .v-input--selection-controls__input {
  margin-right: 8px !important;
}

/* Info Window Override */
:deep(.gm-style-iw-chr) {
  display: none !important;
}

:deep(.gm-style-iw-tc) {
  display: none !important;
}

:deep(.gm-style-iw-d) {
  overflow: visible !important;
  padding: 0 !important;
}

:deep(.gm-style-iw-c) {
  padding: 0 !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15) !important;
}

:deep(.gm-style-iw-t::after) {
  display: none !important;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .header-content {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }

  .page-title {
    justify-content: center;
  }
}

@media (max-width: 768px) {
  .dashboard-container {
    padding: 0 16px;
  }

  .dashboard-header {
    padding: 20px 0;
    margin-bottom: 24px;
  }

  .header-content {
    padding: 0 16px;
  }

  .page-title {
    font-size: 24px;
  }

  .page-subtitle {
    font-size: 14px;
  }

  .filters-card {
    padding: 16px;
  }

  .google-map {
    height: 60vh;
    min-height: 400px;
  }

  .filters-header {
    flex-direction: column;
    gap: 12px;
    align-items: stretch;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
    flex-direction: column;
    gap: 8px;
  }

  .stat-card {
    padding: 12px 16px;
  }

  .stat-number {
    font-size: 20px;
  }

  .google-map {
    height: 50vh;
    min-height: 350px;
  }

  .info-window-content {
    min-width: 180px;
    max-width: 200px;
    padding: 12px;
  }

  .client-name {
    font-size: 14px;
  }
}
</style>